<template>
  <div class="carga-wrapper">

    <!-- ── Barra de acciones ──────────────────────────────────────── -->
	<br>
    <div class="action-bar mb-3" v-if="p_idAutorizacion > 0 || p_frecuenciaCarga === 'M'">
      <button
        v-if="p_idAutorizacion > 0 || p_frecuenciaCarga === 'M'"
        class="action-btn action-btn--primary"
        data-bs-toggle="modal"
        data-bs-target="#ventanaModal"
        @click="abrirModalCrear('planillas')"
        title="Cargar Atenciones"
      >
        <span class="material-symbols-outlined">upload_file</span>
        Cargar Atenciones
      </button>

      <button
        v-if="p_idAutorizacion > 0 || p_frecuenciaCarga === 'M'"
        class="action-btn action-btn--primary"
        data-bs-toggle="modal"
        data-bs-target="#ventanaModal"
        @click="abrirModalCrear('detalles')"
        title="Cargar Detalles"
      >
        <span class="material-symbols-outlined">upload_file</span>
        Cargar Detalles
      </button>

      <button
        v-if="p_idAutorizacion > 0"
        class="action-btn action-btn--teal"
        @click.prevent="abrirModalArchivos(1)"
        title="Carga de Archivos"
      >
        <span class="material-symbols-outlined">drive_folder_upload</span>
        Carga de Archivos
      </button>
    </div>

    <!-- ── Selector registros por página ─────────────────────────── -->
    <div class="d-flex justify-content-end align-items-center gap-2 mb-2" v-if="cargas.length > 0">
      <label class="form-label mb-0 small fw-bold">Mostrar</label>
      <select
        v-model.number="elementosPorPagina"
        class="form-select form-select-sm"
        style="width: 75px;"
        @change="getDataPaginaTodos(1)"
      >
        <option :value="10">10</option>
        <option :value="25">25</option>
        <option :value="50">50</option>
        <option :value="100">100</option>
      </select>
      <span class="small text-muted">registros</span>
    </div>

    <!-- ── Tabla ──────────────────────────────────────────────────── -->
    <div class="table-responsive" v-if="cargas.length > 0">
      <table class="table table-hover table-bordered table-sm" id="sampleTable">
        <thead class="table-dark">
          <tr>
            <th>Fecha desde</th>
            <th>Fecha hasta</th>
            <th>Registros</th>
            <th>Errores</th>
            <th>Acciones</th>
            <th>Opciones</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="carga in datosPaginados"
            :key="carga.idCarga"
            @dblclick="handleRowClick($event, carga.idCarga)"
            title="Doble clic para ver resumen"
            :class="{
              'table-danger':    carga.tieneErrores === 1 && carga.estado === 1,
              'table-secondary': carga.tieneErrores === 1 && carga.estado === 0,
            }"
          >
            <td>{{ getFormattedDate(carga.fechaDesde, 'DD/MM/YYYY') }}</td>
            <td>{{ getFormattedDate(carga.fechaHasta, 'DD/MM/YYYY') }}</td>
            <td>
              <span class="badge bg-primary">{{ carga.numeroRegistros }}</span>
            </td>
            <td>
              <span class="badge" :class="carga.tieneErrores === 1 ? 'bg-danger' : 'bg-success'">
                {{ carga.tieneErrores === 1 ? 'Sí' : 'No' }}
              </span>
            </td>
            <td>
              <div class="icon-btns">
                <button
                  v-if="carga.tienePlanillas === 0"
                  class="icon-btn icon-btn--green"
                  @click.prevent="generarAtenciones(carga.idCarga, 'planillas')"
                  title="Organizar Atenciones Médicas"
                >
                  <span class="material-symbols-outlined">medical_services</span>
                </button>
                <button
                  v-if="carga.tienePlanillas === 0"
                  class="icon-btn icon-btn--blue"
                  @click.prevent="generarAtenciones(carga.idCarga, 'detalles')"
                  title="Organizar Detalles"
                >
                  <span class="material-symbols-outlined">list_alt</span>
                </button>
                <button
                  class="icon-btn icon-btn--red-soft"
                  @click.prevent="borrarCargaCompleta(carga.idCarga)"
                  title="Borrar carga completa"
                >
                  <span class="material-symbols-outlined">delete_forever</span>
                </button>
                <button
                  class="icon-btn icon-btn--red-soft"
                  @click.prevent="borrarCargaTramite(carga.idCarga)"
                  title="Borrar carga trámite"
                >
                  <span class="material-symbols-outlined">delete_forever</span>
                </button>
                <button
                  v-if="carga.tienePlanillas === 1 && carga.tieneArchivos === 0"
                  class="icon-btn icon-btn--teal"
                  @click.prevent="abrirModalArchivos(carga.idCarga)"
                  title="Carga de Archivos"
                >
                  <span class="material-symbols-outlined">drive_folder_upload</span>
                </button>
                <span
                  v-if="carga.tieneErrores === 1 && carga.estado === 0"
                  class="badge bg-secondary"
                >
                  <span class="material-symbols-outlined" style="font-size:11px;vertical-align:middle">block</span>
                  Borrada
                </span>
              </div>
            </td>
            <td>
              <select
                class="form-select form-select-sm"
                @change="handleAction($event, carga.idCarga,
                  getFormattedDate(carga.fechaDesde, 'DD/MM/YYYY'),
                  getFormattedDate(carga.fechaHasta, 'DD/MM/YYYY'))"
              >
                <option disabled selected>Seleccione...</option>
                <option value="resumen">Resumen</option>
                <option value="observaciones">Observaciones</option>
              </select>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr class="table-secondary">
            <td colspan="6" class="text-end fw-bold small">
              Mostrando {{ datosPaginados.length }} de {{ cargas.length }} cargas
            </td>
          </tr>
        </tfoot>
      </table>
    </div>

    <!-- ── Sin resultados ─────────────────────────────────────────── -->
    <div v-if="cargas.length === 0" class="alert alert-warning mt-3" role="alert">
      No se recuperaron registros de carga.
    </div>

    <!-- ── Paginación ─────────────────────────────────────────────── -->
    <div class="d-flex justify-content-between align-items-center mt-3" v-if="cargas.length > 0">
      <span class="small text-muted">
        Página {{ paginaActual }} de {{ totalPaginas() }} — {{ cargas.length }} registros
      </span>
      <nav aria-label="Paginación">
        <ul class="pagination pagination-sm mb-0">
          <li class="page-item" :class="{ disabled: paginaActual === 1 }">
            <a class="page-link" href="#" @click.prevent="getDataPaginaTodos(1)">«</a>
          </li>
          <li class="page-item" :class="{ disabled: paginaActual === 1 }">
            <a class="page-link" href="#" @click.prevent="getPreviousPage()">‹</a>
          </li>
          <li
            v-for="pagina in totalPaginas()"
            :key="pagina"
            class="page-item"
            :class="{ active: pagina === paginaActual }"
          >
            <a class="page-link" href="#" @click.prevent="getDataPaginaTodos(pagina)">{{ pagina }}</a>
          </li>
          <li class="page-item" :class="{ disabled: paginaActual === totalPaginas() }">
            <a class="page-link" href="#" @click.prevent="getNextPage()">›</a>
          </li>
          <li class="page-item" :class="{ disabled: paginaActual === totalPaginas() }">
            <a class="page-link" href="#" @click.prevent="getDataPaginaTodos(totalPaginas())">»</a>
          </li>
        </ul>
      </nav>
    </div>

    <!-- ══════════════════════════════════════════════════════════════
         MODAL
    ═══════════════════════════════════════════════════════════════ -->
    <div
      class="modal fade"
      id="ventanaModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
      v-if="modalWindow"
    >
      <div class="modal-dialog modal-xl">
        <div class="modal-content">

          <!-- Header estándar (igual que TramiteForm) -->
          <div class="modal-header bg-primary">
            <span class="material-symbols-outlined text-white me-2" style="font-size:22px">
              {{ opcionModal === 'crear'   ? 'upload_file'
               : opcionModal === 'resumen' ? 'summarize'
               : 'folder_open' }}
            </span>
            <h5 class="modal-title text-white" id="exampleModalLabel">{{ titulo }}</h5>
            <button
              type="button"
              class="btn-close btn-close-white"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>

          <!-- ── Crear: cargar archivo JSON ── -->
          <div v-if="opcionModal === 'crear'" class="modal-body">
            <div class="upload-zone">
              <div class="upload-zone-icon">
                <span class="material-symbols-outlined">cloud_upload</span>
              </div>
              <p class="upload-zone-desc">
                Carga un archivo <strong>JSON</strong> con el formato del
                <a
                  href="/docs/Manual Técnico para la Carga de Atenciones Médicas mediante Archivo JSON.pdf"
                  target="_blank" rel="noopener noreferrer" class="upload-link"
                >Manual Técnico</a>.
                Asegúrate de que cumpla las especificaciones antes de cargarlo.
              </p>
              <form @submit.prevent="uploadFile" class="w-100">
                <div class="row align-items-end g-3 justify-content-center">
                  <div class="col-md-5">
                    <label class="form-label fw-bold small">Archivo de datos (JSON)</label>
                    <input
                      type="file"
                      id="archivoDatos"
                      class="form-control form-control-sm"
                      @change="handleFileUpload"
                      accept=".json"
                      required
                    />
                    <small class="form-text text-muted">Archivo JSON con los datos a cargar.</small>
                  </div>
                  <div class="col-md-auto">
                    <button type="submit" class="btn btn-outline-success d-flex align-items-center gap-1">
                      <span class="material-symbols-outlined" style="font-size:20px">upload_file</span>
                      <strong>Cargar ({{ opcionCarga }})</strong>
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>

          <!-- ── Resumen de carga ── -->
          <div v-if="opcionModal === 'resumen'" class="modal-body">
            <div class="mb-3">
              <div class="row mb-2">
                <div class="col-2"><label class="form-label fw-bold">IdCarga</label></div>
                <div class="col-4"><span>{{ datoCarga.idCarga }}</span></div>
                <div class="col-2"><label class="form-label fw-bold">Tamaño Archivo</label></div>
                <div class="col-4"><span>{{ datoCarga.tamanioArchivo }}</span></div>
              </div>
              <div class="row mb-2">
                <div class="col-2"><label class="form-label fw-bold">Nº Registros</label></div>
                <div class="col-2"><span>{{ datoCarga.numeroRegistros }}</span></div>
                <div class="col-2"><label class="form-label fw-bold">Fecha Desde</label></div>
                <div class="col-2"><span>{{ getFormattedDate(datoCarga.fechaDesde) }}</span></div>
                <div class="col-2"><label class="form-label fw-bold">Fecha Hasta</label></div>
                <div class="col-2"><span>{{ getFormattedDate(datoCarga.fechaHasta) }}</span></div>
              </div>
              <div class="row mb-2">
                <div class="col-2"><label class="form-label fw-bold">Nombre Archivo</label></div>
                <div class="col-10"><span class="font-monospace small">{{ datoCarga.nombreArchivo }}</span></div>
              </div>
              <div class="row">
                <div class="col-2"><label class="form-label fw-bold">Observaciones</label></div>
                <div class="col-10"><span>{{ datoCarga.obs }}</span></div>
              </div>
            </div>
          </div>

          <!-- ── Carga de archivos PDF ── -->
          <div v-if="opcionModal === 'archivos'" class="modal-body">
            <div class="upload-zone">
              <div class="upload-zone-icon upload-zone-icon--teal">
                <span class="material-symbols-outlined">folder_open</span>
              </div>
              <p class="upload-zone-desc">
                Carga los archivos PDF relacionados con las planillas.
                Selecciona la carpeta o archivos necesarios antes de proceder.
              </p>
              <form @submit.prevent="uploadFiles" class="w-100">
                <div class="row align-items-end g-3 justify-content-center">
                  <div class="col-md-6">
                    <label class="form-label fw-bold small">Archivos de planillas (PDF)</label>
                    <input
                      type="file"
                      id="archivosPlanillas"
                      class="form-control form-control-sm"
                      @change="handleFilesUpload"
                      accept=".pdf"
                      webkitdirectory
                      directory
                      multiple
                      required
                    />
                    <small class="form-text text-muted">Selecciona uno o más archivos PDF de planillas.</small>
                  </div>
                  <div class="col-md-auto">
                    <button
                      type="submit"
                      class="btn btn-outline-success d-flex align-items-center gap-1"
                      :disabled="archivosPlanillas.length === 0 || archivosPlanillas.length > 1000"
                    >
                      <span class="material-symbols-outlined" style="font-size:20px">drive_folder_upload</span>
                      <strong>Cargar archivos</strong>
                    </button>
                  </div>
                </div>
              </form>
              <div v-if="archivosPlanillas.length > 0" class="mt-3 d-flex gap-2 flex-wrap justify-content-center">
                <span class="badge bg-success fs-6">
                  {{ archivosPlanillas.length }} archivo(s) seleccionado(s)
                </span>
                <span v-if="archivosPlanillas.length > 1000" class="badge bg-danger fs-6">
                  Máx. 1000 — divide en {{ Math.ceil(archivosPlanillas.length / 1000) }} bloques
                </span>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/services/api";
import dateFormat from "@/modules/dateFormat.js";
import * as $ from "jquery";
import Swal from "sweetalert2";
window["$"] = $;
window["jQuery"] = $;

export default {
  props: {
    p_idTramite:       { type: Number, required: true },
    p_idAutorizacion:  { type: Number, required: false, default: null },
    p_frecuenciaCarga: { type: String, required: true },
  },
  data() {
    return {
      cargas:               [],
      datoCarga:            {},
      titulo:               "",
      opcionModal:          "",
      opcionCarga:          "",
      elementosPorPagina:   10,
      datosPaginados:       [],
      paginaActual:         1,
      modalWindow:          true,
      p_idUsuario:          0,
      archivoDatos:         null,
      archivosPlanillas:    [],
      idCargaSeleccionada:  0,
      cargaActivaSinArchivos: false,
    };
  },
  async mounted() {
    this.p_idUsuario = window.sessionStorage.getItem("idUsuario");
    await this.getDataPaginaTodos(this.paginaActual);
  },
  methods: {
    handleRowClick(event, idCarga) {
      if (event.target.tagName === "SELECT" || event.target.tagName === "OPTION") return;
      this.abrirModalEditar(idCarga);
    },
    handleAction(event, idCarga, fechaDesde, fechaHasta) {
      const action = event.target.value;
      if (action === "resumen")            this.abrirModalEditar(idCarga, fechaDesde, fechaHasta);
      else if (action === "observaciones") this.abrirObservaciones(idCarga);
      event.target.value = "Seleccione...";
    },
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
    totalPaginas() {
      return Math.max(1, Math.ceil(this.cargas.length / this.elementosPorPagina));
    },
    getDataPaginaTodos(noPagina) {
      const url = !this.p_idAutorizacion
        ? `/vwcargas/idtramite/${this.p_idTramite}`
        : `/vwcargas/idtramite-idautorizacion/${this.p_idTramite}/${this.p_idAutorizacion}`;
      api.get(url).then((response) => {
        this.cargas         = response.data.reverse();
        this.paginaActual   = noPagina;
        const ini           = (noPagina - 1) * this.elementosPorPagina;
        this.datosPaginados = this.cargas.slice(ini, ini + this.elementosPorPagina);
      });
      this.verificarCargasActivas();
    },
    getPreviousPage() {
      if (this.paginaActual > 1) this.getDataPaginaTodos(--this.paginaActual);
    },
    getNextPage() {
      if (this.paginaActual < this.totalPaginas()) this.getDataPaginaTodos(++this.paginaActual);
    },
    abrirModalCrear(opcion) {
      this.modalWindow = true;
      this.datoCarga   = {};
      this.titulo      = "Carga de Archivo de Datos";
      this.opcionModal = "crear";
      this.opcionCarga = opcion;
    },
    abrirModalEditar(idCarga, fechaDesde, fechaHasta) {
      this.modalWindow = true;
      if (idCarga != null) {
        api.get("/vwcargas/" + idCarga).then((resp) => { this.datoCarga = resp.data; });
      }
      $("#ventanaModal").modal("show");
      this.titulo      = `Resumen de la Carga: periodo ${fechaDesde} - ${fechaHasta}`;
      this.opcionModal = "resumen";
    },
    abrirModalArchivos(idCarga) {
      this.modalWindow         = true;
      this.idCargaSeleccionada = idCarga;
      this.titulo              = "Carga de archivos de planillas";
      this.opcionModal         = "archivos";
      $("#ventanaModal").modal("show");
    },
    abrirObservaciones(idCarga) {
      if (idCarga != null) this.$router.push(`/cargaplanillaobs/${this.p_idTramite}/${idCarga}`);
    },
    handleFileUpload(event) { this.archivoDatos = event.target.files[0]; },
    async uploadFile() {
      if (!this.archivoDatos) {
        Swal.fire({ icon: "error", title: "Error", text: "No se ha seleccionado ningún archivo." });
        return;
      }
      const fechaModificacion = this.archivoDatos.lastModified;
      const formData = new FormData();
      formData.append("idTramite",         this.p_idTramite);
      formData.append("idUsuario",         this.p_idUsuario);
      formData.append("fechaModificacion", fechaModificacion);
      formData.append("esCargaDetalles",   this.opcionCarga === "planillas" ? false : true);
      formData.append("file",              this.archivoDatos);
      if (this.p_idAutorizacion != null && !isNaN(this.p_idAutorizacion))
        formData.append("idAutorizacion", this.p_idAutorizacion);
      try {
        Swal.fire({ title: "Un momento, por favor...", text: "Estamos cargando los datos del archivo.", allowOutsideClick: false, showConfirmButton: false, didOpen: () => Swal.showLoading() });
        const response = await api.post("/cargaplanillas/cargar-archivo", formData, { headers: { "Content-Type": "multipart/form-data" } });
        Swal.close();
        await Swal.fire({
          icon: response.data.contadorErrores === 0 ? "success" : "warning",
          title: "Archivo cargado", html: response.data.mensaje, showConfirmButton: true,
        }).then(() => { this.archivoDatos = null; document.getElementById("archivoDatos").value = ""; });
        $("#ventanaModal").modal("hide");
        this.getDataPaginaTodos(this.paginaActual);
      } catch (error) {
        const msg = error.response?.data?.message || error.response?.data?.error || "Error desconocido";
        await Swal.fire({ icon: "error", title: "Error", html: `Hubo un error al cargar los archivos.<br><strong>${msg}</strong>` });
      }
      window.location.reload();
    },
async generarAtenciones(idCarga, opcion) {
  Swal.fire({
    title: "Un momento, por favor...",
    text: "Estamos organizando los registros de atenciones médicas.",
    allowOutsideClick: false,
    showConfirmButton: false,
    didOpen: () => Swal.showLoading()
  });

  try {
    const { data } = await api.post(
      opcion === "planillas"
        ? "/cargaplanillas/generar-planillas"
        : "/cargaplanillas/agregar-detalles",
      null,
      { params: { idTramite: this.p_idTramite, idCarga, idUsuario: this.p_idUsuario } }
    );

    Swal.close();

    const hayErrores = data.contadorErrores > 0;

    await Swal.fire({
      title: hayErrores ? "Proceso completado con advertencias" : "¡Correcto!",
      text: hayErrores
        ? `Se procesaron los registros pero ${data.contadorErrores} planilla(s) tuvieron errores. Revise los detalles.`
        : "¡Atenciones médicas organizadas exitosamente!",
      icon: hayErrores ? "warning" : "success",
      confirmButtonText: "Aceptar"
    });

    this.getDataPaginaTodos(this.paginaActual);

    // Solo emitir si no hubo errores
    if (!hayErrores) {
      this.$emit("estadoTramite", "ESTRUCTURADO");
    }

  } catch (error) {
    Swal.close();
    const mensaje = error.response?.data?.mensaje || "Por favor, inténtelo nuevamente.";
    Swal.fire({
      title: "¡Algo salió mal!",
      text: mensaje,
      icon: "error",
      confirmButtonText: "Aceptar"
    });
  }
},
    async borrarCargaCompleta(idCarga) {
      Swal.fire({
        title: "Un momento, por favor...",
        text: "Estamos eliminando la carga completa.",
        allowOutsideClick: false,
        showConfirmButton: false,
        didOpen: () => Swal.showLoading(),
      });
      try {
        await api.post("/procedimientos/borrar-carga-completa", null, { params: { idTramite: this.p_idTramite, idCarga } });
        Swal.fire({ title: "¡Listo!", text: "La carga fue eliminada con éxito.", icon: "success", confirmButtonText: "Aceptar" });
        this.getDataPaginaTodos(this.paginaActual);
      } catch {
        Swal.fire({ title: "¡Algo salió mal!", text: "Por favor, inténtelo nuevamente.", icon: "error", confirmButtonText: "Aceptar" });
      }
    },
    async borrarCargaTramite(idCarga) {
      Swal.fire({
        title: "Un momento, por favor...",
        text: "Estamos eliminando la carga completa.",
        allowOutsideClick: false,
        showConfirmButton: false,
        didOpen: () => Swal.showLoading(),
      });
      try {
        await api.post("/procedimientos/borrar-carga-tramite", null, { params: { idTramite: this.p_idTramite, idCarga } });
        Swal.fire({ title: "¡Listo!", text: "La carga fue eliminada con éxito.", icon: "success", confirmButtonText: "Aceptar" });
        this.getDataPaginaTodos(this.paginaActual);
      } catch {
        Swal.fire({ title: "¡Algo salió mal!", text: "Por favor, inténtelo nuevamente.", icon: "error", confirmButtonText: "Aceptar" });
      }
    },
    handleFilesUpload(event) { this.archivosPlanillas = event.target.files; },
    async uploadFiles() {
      if (!this.archivosPlanillas || this.archivosPlanillas.length === 0) {
        Swal.fire({ icon: "error", title: "Error", text: "No se ha seleccionado la carpeta contenedora." });
        return;
      }
      const formData = new FormData();
      formData.append("idTramite", this.p_idTramite);
      formData.append("idCarga",   this.idCargaSeleccionada);
      formData.append("idUsuario", window.sessionStorage.getItem("idUsuario"));
      for (let i = 0; i < this.archivosPlanillas.length; i++) {
        const archivo = this.archivosPlanillas[i];
        if (!this.verificarArchivo(archivo)) {
          Swal.fire({ icon: "warning", title: "Archivo no permitido", html: `El archivo <b>${archivo.name}</b> excede el tamaño o tiene formato incorrecto.` });
          return;
        }
        formData.append("archivos", archivo);
      }
      Swal.fire({ title: "Un momento, por favor...", text: "Estamos cargando los archivos de respaldo.", allowOutsideClick: false, showConfirmButton: false, didOpen: () => Swal.showLoading() });
      try {
        const response = await api.post("/archivospla/indexar-directorio", formData, { headers: { "Content-Type": "multipart/form-data" } });
        Swal.close();
        await this.manejarRespuesta(response.data);
        $("#ventanaModal").modal("hide");
        this.getDataPaginaTodos(this.paginaActual);
      } catch (error) { console.error("Error con Axios:", error); }
      window.location.reload();
    },
    async manejarRespuesta(data) {
      if (data.archivosCargados?.length > 0)
        await Swal.fire({ icon: "success", title: "Archivos cargados correctamente", html: `Se han cargado <b>${data.archivosCargados.length}</b> archivos.` });
      if (data.archivosDuplicados?.length > 0)
        await Swal.fire({ icon: "warning", title: "Archivos duplicados", html: `Se encontraron <b>${data.archivosDuplicados.length}</b> archivos duplicados.` });
      if (data.planillasNoEncontradas?.length > 0)
        await Swal.fire({ icon: "error", title: "Planillas no encontradas", html: `<b>${data.planillasNoEncontradas.length}</b> planillas no encontradas.` });
      if (data.archivosCargados?.length > 0)       this.descargarCSV(data.archivosCargados,       "archivosCargados.csv");
      if (data.archivosDuplicados?.length > 0)     this.descargarCSV(data.archivosDuplicados,     "archivosDuplicados.csv");
      if (data.planillasNoEncontradas?.length > 0) this.descargarCSV(data.planillasNoEncontradas, "planillasNoEncontradas.csv");
    },
    descargarCSV(data, nombreArchivo) {
      if (!data || data.length === 0) return;
      let csv = "data:text/csv;charset=utf-8,Nombre de archivo\n";
      data.forEach((a) => { csv += a + "\n"; });
      const link = document.createElement("a");
      link.setAttribute("href", encodeURI(csv));
      link.setAttribute("download", nombreArchivo || "archivos_cargados.csv");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    verificarArchivo(archivo) {
      const tipos = ["application/pdf", "image/jpeg", "image/png"];
      return tipos.includes(archivo.type) && archivo.size <= 10 * 1024 * 1024;
    },
    async verificarCargasActivas() {
      if (!this.p_idTramite) return;
      try {
        const response = await api.get(`/vwcargas/tramite/${this.p_idTramite}/cargas-activas-sin-archivos`);
        this.cargaActivaSinArchivos = response.data;
      } catch (error) { console.error("Error al consultar el servicio:", error); }
    },
  },
};
</script>

<style scoped>
/* ── Barra de acciones ───────────────────────────────────────── */
.action-bar { display: flex; flex-wrap: wrap; gap: 8px; }
.action-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  border: none;
  border-radius: 6px;
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  transition: filter .12s, transform .1s;
}
.action-btn:hover { filter: brightness(1.08); transform: translateY(-1px); }
.action-btn .material-symbols-outlined { font-size: 18px; }
.action-btn--primary { background: #0d6efd; color: #fff; }
.action-btn--teal    { background: #0f9d8c; color: #fff; }

/* ── Botones icon-only ───────────────────────────────────────── */
.icon-btns { display: flex; flex-wrap: wrap; gap: 4px; align-items: center; }
.icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px; height: 30px;
  border-radius: 6px;
  border: 1px solid transparent;
  cursor: pointer;
  background: transparent;
  transition: background .13s, transform .1s;
  padding: 0;
}
.icon-btn:hover { transform: translateY(-1px); }
.icon-btn .material-symbols-outlined { font-size: 17px; }
.icon-btn--green    { color: #2e7d32; border-color: #c8e6c9; }
.icon-btn--green:hover  { background: #e8f5e9; }
.icon-btn--blue     { color: #1a73e8; border-color: #bbdefb; }
.icon-btn--blue:hover   { background: #e8f0fe; }
.icon-btn--red      { color: #c62828; border-color: #ffcdd2; }
.icon-btn--red:hover    { background: #ffebee; }
.icon-btn--red-soft { color: #e53935; border-color: #eeeeee; }
.icon-btn--red-soft:hover { background: #fff3f3; border-color: #ffcdd2; }
.icon-btn--teal     { color: #00897b; border-color: #b2dfdb; }
.icon-btn--teal:hover   { background: #e0f2f1; }

/* ── Upload zone ─────────────────────────────────────────────── */
.upload-zone {
  border: 2px dashed #dee2e6;
  border-radius: 10px;
  padding: 28px 24px;
  background: #f8fafd;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}
.upload-zone-icon {
  width: 52px; height: 52px;
  border-radius: 50%;
  background: #e8f0fe;
  display: flex; align-items: center; justify-content: center;
  margin-bottom: 12px;
}
.upload-zone-icon .material-symbols-outlined { font-size: 28px; color: #1a73e8; }
.upload-zone-icon--teal { background: #e0f2f1; }
.upload-zone-icon--teal .material-symbols-outlined { color: #00897b; }
.upload-zone-desc { color: #6c757d; font-size: 0.88rem; max-width: 560px; margin-bottom: 18px; }
.upload-link { color: #1a73e8; font-weight: 600; }

/* ── Tabla ───────────────────────────────────────────────────── */
.table-hover tbody tr { cursor: pointer; }
</style>